<template>
    <div id="root" class="container">
        <div class="section card-slider1" id="card-slider1">
            <div v-for="c in courses" v-bind:key="c.id" class="card" style="width: 18rem;">
                <div class="card-img-top" style="height: 150px; overflow: hidden;">
                    <img style="height: 150px;" v-if="c.image" :src="c.image"  alt="...">
                    <img style="height: 150px;" v-else src="/images/COURSE_DEFAULT.jpg" alt="...">
                </div>
                <div class="card-body" style="height: 230px;">
                    <!-- <span class="card__badge badge badge-pill badge-warning">Free</span> -->
                    <!-- <img src="/images/dna.svg" class="card__icon--brand" alt=""> -->                 

                    <h5><router-link :to="{ name: 'course_show', params: { id: c.id } }">{{ c.name }}</router-link></h5>

                    <p class="card-text" style="font-weight: bold;">{{c.department.name}}</p>
                    <!-- <p class="small font-weight-bold text-uppercase text-muted">Course</p> -->
                    <p class=" text-muted">
                        <span class="text-uppercase small font-weight-bold">
                            Автор:
                        </span>
                        <router-link :to="{ name: 'user_show', params: { id: c.user_id } }">{{ c.user.name }}</router-link>
                    </p>
                </div>
            </div>       
        </div>
    </div>   
</template>

<script>

import jQuery from 'jquery'
import 'lightslider'

export default {

    props: {
        courses: Array,
    },

    mounted() {
        jQuery('#card-slider1').lightSlider({
            item: 4,
            autoWidth: false,
            galleryMargin: 50,
            slideMove: 1, // slidemove will be 1 if loop is true
            slideMargin: 30,
            loop: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        item: 3,
                        slideMargin: 20
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        item: 2,
                        slideMargin: 10,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        item: 1,
                    }
                }
            ]
        });
    }
    
}
</script>



<style scoped>

.card__icon--brand {
    position: relative;
    top: -50px;
    left: 10px;
    display: block;
    width: 40px;
    background: white;
    border: 10px solid white;
    outline: 1px solid rgba(0,0,0,.1);
    border-radius: 3px;
    box-shadow: 2px 0 2px 2px rgba(0,0,0,.1);
}

.card__badge {
    position: absolute;
    right: 30px;
    display: block;
}

@media (min-width: 768px) { 
    .card__icon--brand {
        position: relative;
        top: -50px;
        left: 10px;
        display: block;
        width: 60px;
        background: white;
        border: 10px solid white;
        outline: 1px solid rgba(0,0,0,.1);
        border-radius: 3px;
        box-shadow: 2px 0 2px 2px rgba(0,0,0,.1);
    }
    
    .card__badge {
        position: absolute;
        right: 50px;
        display: block;
    }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {  
    
    .card__icon--brand {
        position: relative;
        top: -50px;
        left: 10px;
        display: block;
        width: 60px;
        background: white;
        border: 10px solid white;
        outline: 1px solid rgba(0,0,0,.1);
        border-radius: 3px;
        box-shadow: 2px 0 2px 2px rgba(0,0,0,.1);
    }
    
    .card__badge {
        position: absolute;
        right: 50px;
        display: block;
    }
    
}


</style>


